/** 音声入力画面で表示するお題 — 口が動くきっかけになるシンプルな問い */
export const JOURNAL_PROMPTS = [
  '今日何があった？',
  '今、何考えてた？',
  '今日、イラッとしたことあった？',
  'ぶっちゃけ今の気持ちは？',
  '今日、嬉しかったことは？',
  '今、誰かに言いたいことある？',
  '今、何がめんどくさい？',
  '今日、頑張ったことは？',
  '今、悩んでることある？',
  '今日、忘れたくないことは？',
  '今日、学んだことは？',
  '今日、ありがとうって思ったことは？',
  '今日、面白かったことは？',
  '今日、誰と話した？',
  '今、何にモヤモヤしてる？',
] as const;
